var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('SelectableListBase',{attrs:{"titleAdd":"SELECIONAR PRODUTOS:","titleSelected":"PRODUTOS SELECIONADOS:","items":_vm.availableProdutos,"itemsSelected":_vm.form.mixProdutos,"itemKey":"id","columns":[
        { key: 'id', label: 'ID' },
        { key: 'desc', label: 'Produto' },
      ],"loadItems":_vm.searchItems,"itemTransform":(item) => ({
          id: item.id,
          idExibicao: item.idExibicao,
          desc: item.descComp,
        }),"selectCallback":_vm.addProduto,"deselectCallback":_vm.removeProduto,"disableCondition":(item, selected) => selected.some((s) => s.id === item.id),"disableAddCondition":(item) => item.disabled}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }